var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58182 11L0 6.2491L1.42036 4.6706L4.55636 7.9013L11.705 0L13.1529 1.5499L4.58182 11Z",
    fill: "#357221"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkGreen);
export default __webpack_public_path__ + "static/media/check-mark-green.e3791953fac1d7b668c0d6eec62a10aa.svg";
export { ForwardRef as ReactComponent };